/**
 * @generated SignedSource<<c8d89aa79809523aa8b8851b88184193>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentProcessor = "BRAINTREE" | "KLARNA" | "OFF_PLATFORM" | "STRIPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type WalletAchOption_ach$data = {
  readonly accountType: string | null;
  readonly last4: string | null;
  readonly paymentProcessor: PaymentProcessor | null;
  readonly routingNumber: string | null;
  readonly token: string | null;
  readonly " $fragmentType": "WalletAchOption_ach";
};
export type WalletAchOption_ach$key = {
  readonly " $data"?: WalletAchOption_ach$data;
  readonly " $fragmentSpreads": FragmentRefs<"WalletAchOption_ach">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WalletAchOption_ach",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "routingNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentProcessor",
      "storageKey": null
    }
  ],
  "type": "ACH",
  "abstractKey": null
};

(node as any).hash = "d602eda8c76b11314682c25bc03967cc";

export default node;
